export interface ProductData {
  id: string;
  name: string;
  subtitle: string;
  kingdom: string;
  tagline: string;
  heroPhrase: string;
  heroSub: string;
  essenceTitle: string;
  essenceLines: string[];
  ritualTitle: string;
  ritualLines: string[];
  transformations: { from: string; to: string }[];
  details: {
    material: string;
    stone: string;
    type: string;
    price: string;
    collection: string;
  };
  ctaShopifyUrl: string;
  ctaCollectionUrl: string;
  accentColor: string;
  glowColor: string;
  heroImage: string;
  essenceImage: string;
  ritualImage: string;
}

export const products: ProductData[] = [
  {
    id: "celestia",
    name: "Celestia",
    subtitle: "天界の北極星",
    kingdom: "Kingdom of Heaven",
    tagline: "星の記憶を宿す",
    heroPhrase: "迷わない。\n星が知っている。",
    heroSub: "Celestia — Kingdom of Heaven",
    essenceTitle: "天の導き",
    essenceLines: [
      "夜空の最も深い場所に、",
      "あなたの名前が刻まれている。",
      "Celestiaはその記憶を、",
      "あなたの手元に還す。",
    ],
    ritualTitle: "儀式の時",
    ritualLines: [
      "夜明け前の静寂に身を置く。",
      "石を胸に当て、目を閉じる。",
      "問いを手放し、ただ在る。",
      "答えは、すでにそこにある。",
    ],
    transformations: [
      { from: "迷い", to: "方向" },
      { from: "不安", to: "信頼" },
      { from: "孤独", to: "繋がり" },
    ],
    details: {
      material: "18K Gold Vermeil",
      stone: "Star Sapphire",
      type: "Pendant Necklace",
      price: "¥22,000",
      collection: "Kingdom of Heaven",
    },
    ctaShopifyUrl: "https://square.link/u/f5jXSRx8",
    ctaCollectionUrl: "/",
    accentColor: "#7eb8d4",
    glowColor: "rgba(126,184,212,0.15)",
    heroImage: "https://public.readdy.ai/ai/img_res/db7bad042aaf766a71ab615249e8a782.jpg",
    essenceImage: "https://readdy.ai/api/search-image?query=deep%20blue%20star%20sapphire%20gemstone%20close%20up%20macro%20photography%2C%20star%20reflection%20visible%20inside%20stone%2C%20dark%20background%20with%20soft%20blue%20luminescence%2C%20luxury%20spiritual%20jewelry%2C%20cinematic%20lighting%2C%20sacred%20object%20photography%2C%20ultra%20detailed%20crystal%20surface&width=800&height=600&seq=celestia-essence&orientation=landscape",
    ritualImage: "https://readdy.ai/api/search-image?query=woman%20wearing%20sapphire%20necklace%20in%20dark%20minimal%20room%2C%20soft%20blue%20light%20from%20above%2C%20meditative%20pose%2C%20spiritual%20ritual%20atmosphere%2C%20cinematic%20photography%2C%20dark%20background%2C%20luxury%20lifestyle%2C%20sacred%20moment%2C%20no%20face%20visible&width=800&height=600&seq=celestia-ritual&orientation=landscape",
  },
  {
    id: "karmalaya",
    name: "Karmalaya",
    subtitle: "カルマの浄化",
    kingdom: "Kingdom of Lotus",
    tagline: "過去を手放す儀式",
    heroPhrase: "手放すことが、\n始まりだった。",
    heroSub: "Karmalaya — Kingdom of Lotus",
    essenceTitle: "浄化の波紋",
    essenceLines: [
      "蓮は泥の中から生まれる。",
      "あなたの傷もまた、",
      "光への道だった。",
      "Karmalayaは、その変容を抱く。",
    ],
    ritualTitle: "手放しの儀式",
    ritualLines: [
      "水辺に座り、石を両手で包む。",
      "手放したいものを、静かに思う。",
      "息を吐くたびに、それは溶けていく。",
      "残るのは、清らかな自分だけ。",
    ],
    transformations: [
      { from: "執着", to: "解放" },
      { from: "罪悪感", to: "赦し" },
      { from: "重さ", to: "軽やかさ" },
    ],
    details: {
      material: "Sterling Silver 925",
      stone: "Rose Quartz",
      type: "Lotus Pendant",
      price: "¥20,000",
      collection: "Kingdom of Lotus",
    },
    ctaShopifyUrl: "https://square.link/u/dyI7TJoz",
    ctaCollectionUrl: "/",
    accentColor: "#d4a0b0",
    glowColor: "rgba(212,160,176,0.15)",
    heroImage: "https://readdy.ai/api/search-image?query=rose%20quartz%20lotus%20carved%20pendant%20necklace%20floating%20in%20dark%20atmosphere%2C%20soft%20pink%20crystal%20with%20golden%20setting%2C%20luxury%20spiritual%20jewelry%20macro%20photography%2C%20cinematic%20warm%20rose%20pink%20lighting%2C%20pure%20black%20background%2C%20sacred%20lotus%20energy%2C%20ultra%20high%20end%20product%20photography%2C%20delicate%20feminine%20energy%2C%20no%20text&width=900&height=1100&seq=karmalaya-hero&orientation=portrait",
    essenceImage: "https://readdy.ai/api/search-image?query=rose%20quartz%20crystal%20close%20up%20macro%20photography%2C%20soft%20pink%20translucent%20stone%2C%20dark%20background%20with%20warm%20rose%20glow%2C%20luxury%20spiritual%20jewelry%2C%20cinematic%20lighting%2C%20sacred%20object%20photography%2C%20lotus%20petal%20texture%2C%20ultra%20detailed%20crystal%20surface&width=800&height=600&seq=karmalaya-essence&orientation=landscape",
    ritualImage: "https://readdy.ai/api/search-image?query=hands%20holding%20rose%20quartz%20crystal%20near%20water%20surface%2C%20soft%20pink%20light%20reflection%2C%20meditative%20ritual%20atmosphere%2C%20cinematic%20photography%2C%20dark%20background%2C%20luxury%20spiritual%20lifestyle%2C%20sacred%20cleansing%20moment%2C%20minimal%20composition&width=800&height=600&seq=karmalaya-ritual&orientation=landscape",
  },
  {
    id: "mandara",
    name: "Mandara",
    subtitle: "豊かさの炎",
    kingdom: "Kingdom of Gold",
    tagline: "意図を形にする力",
    heroPhrase: "望むのではない。\n在ることで、引き寄せる。",
    heroSub: "Mandara — Kingdom of Gold",
    essenceTitle: "黄金の意図",
    essenceLines: [
      "豊かさとは、外から来ない。",
      "それはあなたの内側で、",
      "すでに燃えている。",
      "Mandaraは、その炎を呼び覚ます。",
    ],
    ritualTitle: "顕現の儀式",
    ritualLines: [
      "朝の光の中で石を手に取る。",
      "今日の意図を、一言で決める。",
      "その言葉を石に吹き込む。",
      "あとは、信じて動くだけ。",
    ],
    transformations: [
      { from: "欠乏感", to: "豊かさ" },
      { from: "疑い", to: "確信" },
      { from: "停滞", to: "流れ" },
    ],
    details: {
      material: "24K Gold Plated",
      stone: "Citrine",
      type: "Mandala Ring",
      price: "¥5,500",
      collection: "Kingdom of Gold",
    },
    ctaShopifyUrl: "https://square.link/u/lYl6LYWY",
    ctaCollectionUrl: "/",
    accentColor: "#d4a84c",
    glowColor: "rgba(212,168,76,0.18)",
    heroImage: "https://readdy.ai/api/search-image?query=golden%20citrine%20mandala%20ring%20floating%20in%20dark%20atmosphere%2C%20yellow%20crystal%20gemstone%20with%20intricate%2024k%20gold%20setting%2C%20luxury%20spiritual%20jewelry%20macro%20photography%2C%20cinematic%20warm%20amber%20golden%20lighting%2C%20pure%20black%20background%2C%20sacred%20geometry%20energy%2C%20ultra%20high%20end%20product%20photography%2C%20abundance%20manifestation%2C%20no%20text&width=900&height=1100&seq=mandara-hero&orientation=portrait",
    essenceImage: "https://readdy.ai/api/search-image?query=citrine%20crystal%20close%20up%20macro%20photography%2C%20golden%20yellow%20translucent%20stone%2C%20dark%20background%20with%20warm%20amber%20glow%2C%20luxury%20spiritual%20jewelry%2C%20cinematic%20lighting%2C%20sacred%20object%20photography%2C%20mandala%20pattern%20reflection%2C%20ultra%20detailed%20crystal%20surface&width=800&height=600&seq=mandara-essence&orientation=landscape",
    ritualImage: "https://readdy.ai/api/search-image?query=hand%20wearing%20golden%20citrine%20ring%20in%20morning%20light%2C%20warm%20golden%20sunlight%2C%20meditative%20ritual%20atmosphere%2C%20cinematic%20photography%2C%20dark%20to%20light%20background%2C%20luxury%20spiritual%20lifestyle%2C%20sacred%20manifestation%20moment%2C%20minimal%20composition&width=800&height=600&seq=mandara-ritual&orientation=landscape",
  },
  {
    id: "luminara",
    name: "Luminara",
    subtitle: "直観の覚醒",
    kingdom: "Kingdom of Aura",
    tagline: "見えないものを見る",
    heroPhrase: "知識ではない。\n魂が、知っている。",
    heroSub: "Luminara — Kingdom of Aura",
    essenceTitle: "オーラの言語",
    essenceLines: [
      "言葉になる前の知恵がある。",
      "感じる前の感覚がある。",
      "Luminaraはその閾値に宿り、",
      "あなたの直観を目覚めさせる。",
    ],
    ritualTitle: "覚醒の儀式",
    ritualLines: [
      "静かな夜、石を第三の目に当てる。",
      "思考を手放し、感覚に委ねる。",
      "浮かぶイメージを、ただ観る。",
      "それがあなたへのメッセージ。",
    ],
    transformations: [
      { from: "混乱", to: "明晰" },
      { from: "疑念", to: "直観" },
      { from: "雑音", to: "静寂" },
    ],
    details: {
      material: "18K Gold Vermeil",
      stone: "Amethyst",
      type: "Drop Earrings",
      price: "¥5,500",
      collection: "Kingdom of Aura",
    },
    ctaShopifyUrl: "https://square.link/u/ESY1WtmA",
    ctaCollectionUrl: "/",
    accentColor: "#a07cc5",
    glowColor: "rgba(160,124,197,0.15)",
    heroImage: "https://readdy.ai/api/search-image?query=amethyst%20purple%20crystal%20drop%20earrings%20floating%20in%20dark%20atmosphere%2C%20violet%20gemstone%20with%20golden%20setting%2C%20luxury%20spiritual%20jewelry%20macro%20photography%2C%20cinematic%20deep%20purple%20violet%20lighting%2C%20pure%20black%20background%2C%20mystical%20aura%20energy%2C%20ultra%20high%20end%20product%20photography%2C%20wisdom%20higher%20consciousness%2C%20no%20text&width=900&height=1100&seq=luminara-hero&orientation=portrait",
    essenceImage: "https://readdy.ai/api/search-image?query=amethyst%20crystal%20close%20up%20macro%20photography%2C%20deep%20violet%20purple%20translucent%20stone%2C%20dark%20background%20with%20soft%20purple%20luminescence%2C%20luxury%20spiritual%20jewelry%2C%20cinematic%20lighting%2C%20sacred%20object%20photography%2C%20aura%20energy%20field%2C%20ultra%20detailed%20crystal%20surface&width=800&height=600&seq=luminara-essence&orientation=landscape",
    ritualImage: "https://readdy.ai/api/search-image?query=woman%20wearing%20amethyst%20earrings%20in%20dark%20minimal%20space%2C%20soft%20purple%20light%2C%20meditative%20third%20eye%20ritual%20atmosphere%2C%20cinematic%20photography%2C%20dark%20background%2C%20luxury%20spiritual%20lifestyle%2C%20sacred%20intuition%20moment%2C%20no%20face%20visible%2C%20minimal%20composition&width=800&height=600&seq=luminara-ritual&orientation=landscape",
  },
  {
    id: "crystara",
    name: "Crystara Codex",
    subtitle: "魂の図書館",
    kingdom: "Kingdom of Crystal",
    tagline: "すべての記録を宿す",
    heroPhrase: "忘れていない。\n魂は、すべてを覚えている。",
    heroSub: "Crystara Codex — Kingdom of Crystal",
    essenceTitle: "水晶の記憶",
    essenceLines: [
      "水晶は地球の記憶装置。",
      "あなたの魂もまた、",
      "すべての旅を記録している。",
      "Crystara Codexは、その扉を開く。",
    ],
    ritualTitle: "記録の儀式",
    ritualLines: [
      "満月の夜、石を月光に当てる。",
      "今世で学んだことを思い返す。",
      "感謝を込めて、石に語りかける。",
      "あなたの物語は、ここに刻まれる。",
    ],
    transformations: [
      { from: "忘却", to: "記憶" },
      { from: "不透明", to: "透明" },
      { from: "断片", to: "統合" },
    ],
    details: {
      material: "Sterling Silver 925",
      stone: "Clear Quartz",
      type: "Cuff Bracelet",
      price: "¥27,500",
      collection: "Kingdom of Crystal",
    },
    ctaShopifyUrl: "https://square.link/u/JlXGtiyh",
    ctaCollectionUrl: "/",
    accentColor: "#c8d8e0",
    glowColor: "rgba(200,216,224,0.12)",
    heroImage: "https://readdy.ai/api/search-image?query=clear%20quartz%20crystal%20cuff%20bracelet%20floating%20in%20dark%20atmosphere%2C%20transparent%20crystal%20with%20silver%20setting%2C%20luxury%20spiritual%20jewelry%20macro%20photography%2C%20cinematic%20white%20silver%20light%20refraction%2C%20pure%20black%20background%2C%20sacred%20crystal%20memory%20energy%2C%20ultra%20high%20end%20product%20photography%2C%20soul%20record%20transparency%2C%20no%20text&width=900&height=1100&seq=crystara-hero&orientation=portrait",
    essenceImage: "https://readdy.ai/api/search-image?query=clear%20quartz%20crystal%20close%20up%20macro%20photography%2C%20transparent%20crystal%20with%20light%20refraction%2C%20dark%20background%20with%20white%20silver%20luminescence%2C%20luxury%20spiritual%20jewelry%2C%20cinematic%20lighting%2C%20sacred%20object%20photography%2C%20crystal%20memory%20record%2C%20ultra%20detailed%20crystal%20surface&width=800&height=600&seq=crystara-essence&orientation=landscape",
    ritualImage: "https://readdy.ai/api/search-image?query=hand%20wearing%20clear%20quartz%20bracelet%20under%20moonlight%2C%20soft%20silver%20white%20light%2C%20meditative%20ritual%20atmosphere%2C%20cinematic%20photography%2C%20dark%20background%2C%20luxury%20spiritual%20lifestyle%2C%20sacred%20crystal%20memory%20moment%2C%20minimal%20composition&width=800&height=600&seq=crystara-ritual&orientation=landscape",
  },
];

export const getProductById = (id: string): ProductData | undefined =>
  products.find((p) => p.id === id);
